import rawData from '../data/AccessoryItems.json';
import rawTierData from '../data/AccessoryTiers.json';
import {
  AccessoryItem,
  AccessoryItemID,
  AccessorySlot,
  AccessoryThemeID,
} from '../data/AccessoryItems.schema';
import { AccessoryTier, AccessoryTierID } from '../data/AccessoryTiers.schema';

export type { AccessoryItem, AccessoryItemID, AccessoryThemeID, AccessorySlot };
export type { AccessoryTier, AccessoryTierID };

const data = rawData as AccessoryItem[];
const tierData = rawTierData as AccessoryTier[];

// Return typed data array
export const accessoryItems: readonly AccessoryItem[] = data;

// Improve slots naming
export type AccessoryType =
  | 'headwear'
  | 'eyewear'
  | 'facewear'
  | 'neckwear'
  | 'backwear'; // Return typed data map for optimized access by id
export const accessoryItemsMap: Map<AccessoryItemID, AccessoryItem> =
  data.reduce((acc, item) => acc.set(item.id, item), new Map());

// Maps items to tiers using item id and tier id.
export const tiers = {} as Record<AccessoryTierID, AccessoryTier>;
export const tiersAccessoryItemsMap = {} as Record<
  AccessoryItemID,
  typeof tiers
>;
tierData.forEach((tier) => {
  tiers[tier.id] = tier;

  if (!tiersAccessoryItemsMap[tier.item_id]) {
    tiersAccessoryItemsMap[tier.item_id] = {} as any;
  }
  tiersAccessoryItemsMap[tier.item_id][tier.id] = tier;
});
